{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"extensionsUsed": ["KHR_materials_specular"],
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube",
			"scale": [1, 0.9644074440002441, 1],
			"translation": [0, 1.7442471981048584, 0]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"extensions": {
				"KHR_materials_specular": {
					"specularColorFactor": [1.2285715341567993, 1.2285715341567993, 1.2285715341567993]
				}
			},
			"name": "metal",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.03453643620014191, 0.03453643620014191, 0.03453643620014191, 1],
				"metallicFactor": 0.28346458077430725,
				"roughnessFactor": 0.5658267736434937
			}
		}
	],
	"meshes": [
		{
			"name": "Cube",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 109,
			"max": [1.264186143875122, 1, 2.7741549015045166],
			"min": [-1.2796247005462646, -2.0132970809936523, -2.7005486488342285],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 109,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 109,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 180,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 1308,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1308,
			"byteOffset": 1308,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 872,
			"byteOffset": 2616,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 360,
			"byteOffset": 3488,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 3848,
			"uri": "anvil.bin"
		}
	]
}
